import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";

// Layout Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppWidget from "./components/WhatsAppWidget";
import ScrollToTop from "./components/ScrollToTop";

// Pages
import HomePage from "./pages/HomePage";
import CSCSServicesPage from "./pages/CSCSServicesPage";
import NVQCoursesPage from "./pages/NVQCoursesPage";
import CPCSCoursesPage from "./pages/CPCSCoursesPage";
import SiteManagementPage from "./pages/SiteManagementPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import FAQPage from "./pages/FAQPage";
import GreenLabourCardPage from "./pages/GreenLabourCardPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import BookTestPage from "./pages/BookTestPage";
import BookingSuccessPage from "./pages/BookingSuccessPage";
import CSCSApplicationPage from "./pages/CSCSApplicationPage";
import CSCSSuccessPage from "./pages/CSCSSuccessPage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  // Test backend connection on mount
  useEffect(() => {
    const testBackend = async () => {
      try {
        const response = await axios.get(`${API}/`);
        console.log('Backend connected:', response.data.message);
      } catch (e) {
        console.error('Backend connection error:', e);
      }
    };
    testBackend();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/cscs-services" element={<CSCSServicesPage />} />
            <Route path="/green-labour-card" element={<GreenLabourCardPage />} />
            <Route path="/nvq-courses" element={<NVQCoursesPage />} />
            <Route path="/cpcs-courses" element={<CPCSCoursesPage />} />
            <Route path="/site-management" element={<SiteManagementPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/book-test" element={<BookTestPage />} />
            <Route path="/booking-success" element={<BookingSuccessPage />} />
            <Route path="/apply-cscs" element={<CSCSApplicationPage />} />
            <Route path="/cscs-success" element={<CSCSSuccessPage />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppWidget />
      </BrowserRouter>
    </div>
  );
}

export default App;
